const baseUrl = process.env.VUE_APP_API_URL || "http://localhost:3000";

const fetchOpts = { cache: "no-store" };

export function getAuctionsCurrent(params = {}) {
  const q = new URLSearchParams(params).toString();
  return fetch(`${baseUrl}/auctions/current${q ? "?" + q : ""}`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getAuctionsHistory(params = {}) {
  const q = new URLSearchParams(params).toString();
  return fetch(`${baseUrl}/auctions/history${q ? "?" + q : ""}`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getAuctionsStats(params = {}) {
  const q = new URLSearchParams(params).toString();
  return fetch(`${baseUrl}/auctions/stats${q ? "?" + q : ""}`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getAuctionsRecords() {
  return fetch(`${baseUrl}/auctions/records`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getPricePrediction(params = {}) {
  const q = new URLSearchParams(params).toString();
  return fetch(`${baseUrl}/auctions/price-prediction${q ? "?" + q : ""}`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function characterLookup(name) {
  return fetch(`${baseUrl}/characters/lookup`, {
    ...fetchOpts,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: String(name || "").trim() }),
  }).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getCharacterLookupStatus(jobId) {
  return fetch(`${baseUrl}/characters/lookup/status/${jobId}`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getWorlds() {
  return fetch(`${baseUrl}/worlds`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getWorldsHistory(params = {}) {
  const q = new URLSearchParams(params).toString();
  return fetch(`${baseUrl}/worlds/history${q ? "?" + q : ""}`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getWorldsTopLevelChanges() {
  return fetch(`${baseUrl}/worlds/top-level-changes`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getWorld(name) {
  return fetch(`${baseUrl}/worlds/${encodeURIComponent(name)}`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

export function getWorldInsights(name) {
  return fetch(`${baseUrl}/worlds/${encodeURIComponent(name)}/insights`, fetchOpts).then((r) => {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}
